import React from 'react'
import { Controller } from 'react-hook-form'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  Tooltip,
} from '@material-ui/core'
import clsx from 'clsx'

import constants from 'constants/index'
import useStyles from './styles'

const SolutionController = ({
  solution,
  groupFieldName,
  allValues,
  errors,
  control,
}) => {
  const { SOLUTION_MANAGEABLE, OWNED_BY, STATUSES } = constants.dai.solutions

  const classes = useStyles()

  const isGroupOnly =
    solution.manageable === SOLUTION_MANAGEABLE.GROUP_ONLY && !!groupFieldName
  const isLockedByCollaborator = solution.ownedBy === OWNED_BY.COLLABORATOR
  const isLockedByOrganization = solution.ownedBy === OWNED_BY.ORGANIZATION
  const isLockedByOwner =
    (isLockedByCollaborator || isLockedByOrganization) &&
    solution.status === STATUSES.DISABLED
  const isLocked = isGroupOnly || isLockedByOwner

  const tooltipTitle = isGroupOnly
    ? 'Esta solução é gerenciada pelo grupo e não pode ser configurada individualmente.'
    : isLockedByOwner
    ? 'Esta funcionalidade não está disponível. Entre em contato com o administrador para mais informações.'
    : ''

  const isChecked = isGroupOnly
    ? allValues[groupFieldName] !== STATUSES.DISABLED
    : allValues[solution.tag] !== STATUSES.DISABLED

  const handleStatusChange = (checked) =>
    checked ? STATUSES.ENABLED : STATUSES.DISABLED

  const label = (
    <FormControlLabel
      label={solution.name}
      labelPlacement="start"
      classes={{
        root: clsx(classes.formControlLabel, {
          [classes.disabledLabel]: isLocked,
        }),
      }}
      control={
        <Tooltip title={tooltipTitle || ''}>
          <Box className={clsx({ [classes.locked]: isLocked })}>
            <Switch checked={isChecked} color="primary" disabled={isLocked} />
          </Box>
        </Tooltip>
      }
    />
  )

  if (isGroupOnly) return <FormControl fullWidth>{label}</FormControl>

  return (
    <Controller
      as={
        <FormControl fullWidth>
          {label}
          {!!errors?.[solution.tag] && (
            <FormHelperText error>
              {errors?.[solution.tag]?.message}
            </FormHelperText>
          )}
        </FormControl>
      }
      control={control}
      name={solution.tag}
      onChange={([event]) => handleStatusChange(event.target.checked)}
    />
  )
}

export default SolutionController
